const currentVersion = "1.96.365"
const currentMajorReleaseNumber = parseInt(currentVersion.split(".")[1], 10)
const currentMinorReleaseNumber = parseInt(currentVersion.split(".")[2], 10)

export const oldVersionTest = ({
    buildsignature,
    categoryid,
    createtime,
    desyncdata,
    desyncid,
    screenshot,
    sessionid,
    sku,
    systemconfig,
    type,
    version,
}) => {
    if (buildsignature !== undefined) {
        let isOutdated = true
        const buildSplit = buildsignature.split(".")

        if (buildSplit.length > 5) {
            const majorReleaseNumber = parseInt(buildSplit[4], 10)
            const minorReleaseNumber = parseInt(buildSplit[5], 10)

            if (!isNaN(majorReleaseNumber) && !isNaN(minorReleaseNumber)) {
                if (majorReleaseNumber > currentMajorReleaseNumber) {
                    isOutdated = false
                } else if (majorReleaseNumber === currentMajorReleaseNumber) {
                    if (minorReleaseNumber >= currentMinorReleaseNumber) {
                        isOutdated = false
                    }
                }
            }
        }

        if (isOutdated) {
            return {
                type: 'oldVersionTest',
                nonError: true,
                color: 'IndianRed',
                title: '[!!!] Outdated Game',
                text: 'Your game version is outdated!',
                description: 'Running an outdated version of the game will almost always cause issues, especially with mods.<br/><br/>Open <strong>Origin</strong> and update The Sims 4 to the most up-to-date release.'
            }
        }
    }
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>c57deebea21a68525b3fdfe6</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-07-06 16:36:21</createtime>
        <buildsignature>Local.Unknown.Unknown.1.44.83.1020-1.200.000.350.Release</buildsignature>
        <categoryid>weather_service.py:1645</categoryid>
        <desyncid>c57deebea21a68525b3fdfe6</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>...</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/critical/oldVersionTest.js